import * as React from 'react';
import * as styles from './PaymentMethods.css';
import { UIHeading3 } from '@cian/ui-kit';
import { WarningContainer } from './components/Warning';

interface IProps {
  title: string;
  methods: React.ReactNode;
}

export const PaymentMethods = (props: IProps) => {
  const { title, methods } = props;

  return (
    <div className={styles['wrapper']}>
      <UIHeading3>{title}</UIHeading3>

      <div className={styles['container']}>{methods}</div>

      <WarningContainer />
    </div>
  );
};
